import React from "react";
import { Apple } from "lucide-react";

export const APP_STORE_URL = "https://apps.apple.com/au/app/id6807064901";

export const AppStoreBadge = ({ size = "md", className = "", testId = "app-store-badge" }) => (
  <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" data-testid={testId}
    className={`inline-flex items-center gap-2 rounded-lg bg-black text-white border border-white/20 hover:bg-neutral-800 transition-colors ${size === "sm" ? "h-9 px-3" : "h-12 px-4"} ${className}`}>
    <Apple className={size === "sm" ? "h-4 w-4" : "h-6 w-6"} fill="currentColor" />
    <span className="leading-none text-left">
      <span className={`block ${size === "sm" ? "text-[8px]" : "text-[10px]"} opacity-80`}>Download on the</span>
      <span className={`block font-semibold ${size === "sm" ? "text-xs" : "text-base"}`}>App Store</span>
    </span>
  </a>
);
